
import { Component, Vue } from 'vue-property-decorator';

import axios, { AxiosResponse } from 'axios';

import { UserRole } from '@/lib/models';

@Component
export default class UserRoles extends Vue {
  private userRoles: UserRole[] = [];

  private isLoading: boolean = false;
  private currentPage: number = 1;
  private totalRows: number = 0;
  private pageOptions: number[] = [5, 10, 15, 20];
  private perPage: number = 10;

  private userRoleFilter = {
    name: '',
    description: '',
  };

  private userRoleFields: any[] = [
    {
      key: 'name',
      sortable: true,
    },
    {
      key: 'description',
      sortable: true,
    },
    {
      key: 'actions',
      sortable: false,
    },
  ];

  private created(): void {
    this.isLoading = true;
    this.getUserRoles()
      .then((response) => {
        this.userRoles = response.data.data;
        this.totalRows = response.data.meta.total;
      }).catch((error) => {
        const message: string = error.response?.data?.message ?? error.message;
        this.$bvModal.msgBoxOk(message, {
          title: 'Error Getting User Roles',
          okVariant: 'danger',
          centered: true,
        });
      }).finally(() => {
        this.isLoading = false;
      });
  }

  private async getUserRoles(): Promise<AxiosResponse<any>> {
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/user-roles?limit=999999999`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }
}
